import { render } from "./CommunicationReadySendContainer.vue?vue&type=template&id=1647d4af&scoped=true&ts=true"
import script from "./CommunicationReadySendContainer.vue?vue&type=script&lang=ts"
export * from "./CommunicationReadySendContainer.vue?vue&type=script&lang=ts"

import "./CommunicationReadySendContainer.vue?vue&type=style&index=0&id=1647d4af&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1647d4af"]])

export default __exports__